import Vec2 from 'vec2';

export class SimpleLine {
  point1: Vec2;
  point2: Vec2;

  constructor(p1: Vec2, p2: Vec2) {
    this.point1 = new Vec2(p1.x, p1.y);
    this.point2 = new Vec2(p2.x, p2.y);
  }
}
